// extracted by mini-css-extract-plugin
export default {"cls1":"tVoHwtRrfn20TAczhy0q","cls2":"oue4VQCcb3MtbjvRT1gS tVoHwtRrfn20TAczhy0q"};